export const boldText = {
  fontSize: '20px',
  fontWeight: '600',
  lineHeight: '2.25rem',
  cursor: 'pointer',
};
export const normalText = {
  fontSize: '16px',
  fontWeight: '400',
  lineHeight: '2.25rem',
  cursor: 'pointer',
};
export const containerStyle = {
  gap: { sm: '3rem' },
  color: 'text.grey',
  justifyContent: 'center',
};
export const imgCarouselLR = {
  p: '12px',
  bg: 'common.grey05',
  height: { base: '101px', sm: '116px', md: '207px' },
  cursor: 'pointer',
};
export const imgCarouselStyles = {
  p: '12px',
  bg: 'brand.tertiary',
  height: { base: '110px', sm: '157.21px', md: '287.9px' }
};
export const txtCarouselLR = {
  textStyle: 'body1',
  cursor: 'pointer',
};
export const txtCarouselStyles = {
  textStyle: 'body1',
  cursor: 'default',
  mx: 5,
  fontWeight: '600',
};
export const carouselIcon = {
  my: 'auto',
  cursor: 'pointer',
  p: '0 15px',
};
